import { twClassMerge } from '@healthhub/react-ui';
import { useEffect, useState } from 'react';

import { useLayoutViewContext } from '@shared/context';

interface StickyFooterBarProps {
  children: React.ReactNode;
  className?: string;
}

const StickyFooterBar = ({ children, className }: StickyFooterBarProps) => {
  const { isPortalView } = useLayoutViewContext();

  const [isScrollToBottomPortal, setIsScrollToBottomPortal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.getElementById('footer');
      const footerHeight = footer?.offsetHeight;

      if (footerHeight) {
        const position =
          Math.ceil(window.scrollY + window.innerHeight) >= document.documentElement.scrollHeight - footerHeight &&
          isPortalView;
        setIsScrollToBottomPortal(position);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isPortalView]);

  return (
    <div className={className}>
      <div
        className={twClassMerge('fixed bottom-0 left-0 right-auto z-sticky w-full', {
          'relative shadow-[0px_-1px_12px_0px_rgba(0,0,0,0.25)] bg-primary-grey': isScrollToBottomPortal,
        })}
      >
        <div
          className={twClassMerge('relative m-0 h-24.5 w-full', className, {
            'mx-auto': isScrollToBottomPortal,
            'mx-auto max-w-7xl items-center lg:max-w-5xl': isPortalView,
          })}
        >
          <div
            className={twClassMerge(
              'absolute left-0 right-0 px-4 py-5 w-full shadow-[0px_-1px_12px_0px_rgba(0,0,0,0.25)] bg-primary-grey',
              {
                'left-auto shadow-none bg-none': isScrollToBottomPortal,
              }
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyFooterBar;
